import styled from "styled-components";

export const RatingStarButton = styled.button`
  padding: 0;
  margin: 0;
  background: none;
  border: none;
  cursor: pointer;
  width: 32px;
  height: 32px;
`;

export const RatingWrapper = styled.div`
  display: flex;
  gap: 6px;
  margin-top: 4px;
  margin-bottom: 4px;
`;

export const RatingStar = styled.svg`
  width: 27px;
  height: 27px;

  path {
    transition: 0.15s;
    fill: var(--grey-primary);
  }

  &.active {
    path {
      fill: orange;
    }
  }

  &.hover {
    path {
      fill: var(--white-secondary);
    }
  }
`;
